import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useCustomerItem } from '../../../../hooks';
import { CustomerItemDataProps } from '../../../../utils/types';

import { Skeleton } from './components/Skeleton';
import { AddedCustomerItemDesktop } from './desktop';
import { AddedCustomerItemMobile } from './mobile';

interface AddedCustomerItemProps {
  item: CustomerItemDataProps;
}

export interface AddedCustomerItemResponsiveProps extends AddedCustomerItemProps {
  handleRemoveCustomerToCart: () => void;
  handleUpdateBalance: () => Promise<void>;
  isLoadingBalance: boolean;
}

export const AddedCustomerItem: React.FC<AddedCustomerItemProps> = ({ item }) => {
  const {
    customerTagList,
    handleRemoveCustomerToCart,
    handleUpdateBalance,
    isLoadingBalance,
    availableBalance,
    isLoadingAction,
  } = useCustomerItem({
    customerItem: item,
  });

  const itemData = {
    ...item,
    availableBalance,
    tags: [...customerTagList, ...(item?.hashtags ?? [])],
  };

  const props = {
    item: itemData,
    handleRemoveCustomerToCart,
    handleUpdateBalance,
    isLoadingBalance,
  };

  const layout = useBreakpointValue({
    base: <AddedCustomerItemMobile {...props} />,
    sm: <AddedCustomerItemDesktop {...props} />,
  });

  if (isLoadingAction) {
    return <Skeleton />;
  }

  return layout;
};
